"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MagneticShield = void 0;
var Card_1 = require("../Card");
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var Tags_1 = require("../Tags");
var PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
var PartyName_1 = require("../../turmoil/parties/PartyName");
var constants_1 = require("../../constants");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var MagneticShield = (function (_super) {
    __extends(MagneticShield, _super);
    function MagneticShield() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.MAGNETIC_SHIELD,
            tags: [Tags_1.Tags.SPACE],
            cost: 24,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.tag(Tags_1.Tags.ENERGY, 3); }),
            metadata: {
                cardNumber: 'X24',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) { return b.tr(4).digit; }),
                description: 'Requires 3 power tags. Raise your TR 4 steps.',
            },
        }) || this;
    }
    MagneticShield.prototype.canPlay = function (player) {
        if (!_super.prototype.canPlay.call(this, player)) {
            return false;
        }
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player.game, PartyName_1.PartyName.REDS)) {
            return player.canAfford(player.getCardCost(this) + constants_1.REDS_RULING_POLICY_COST * 4, { titanium: true });
        }
        return true;
    };
    MagneticShield.prototype.play = function (player) {
        player.increaseTerraformRatingSteps(4);
        return undefined;
    };
    return MagneticShield;
}(Card_1.Card));
exports.MagneticShield = MagneticShield;
//# sourceMappingURL=MagneticShield.js.map